import React from 'react';

const InfoMessage = (props) => {
  return (
    <div className="common-notification info">
      <div className="matchMessage">
        <p className="sub-header-firstRow infotitle">{props.title}</p>
        <p className="infomessage">
          {props.message}
        </p>
      </div>
    </div>
  );
}

export default InfoMessage;